import BaseService, { RequestInterface } from '../Base';
import { AwsConfig as AwsConstants } from '../Constants';

export default class EhssTicketEventService extends BaseService {
    constructor() {
        super(AwsConstants.API_EHSS, 'ticket-event')
    }

    async getProcessGoals(query: any, unit: string, processId: any, year: any){
        const params: RequestInterface = {
            queryStringParameters: { unit: unit }
        }
        if(query.auditedOut){
            params.queryStringParameters['auditedOut'] = query.auditedOut
        }
        if(query.auditedGuest){
            params.queryStringParameters['auditedGuest'] = query.auditedGuest
        }
        if(query.auditorGuest){
            params.queryStringParameters['auditorGuest'] = query.auditorGuest
        }
        if(query.auditors){
            params.queryStringParameters['auditors'] = query.auditors
        }
        if (Array.isArray(query.owners) && query.owners.length) {
            params.queryStringParameters['owners'] = query.owners.join(',')
        }
        
        const res = await super.get(`process/${processId}/goals/${year}`, params)
        return res;
    }

    async getDashboardData(processID: string, query: any) {

        const params: any = {
            body: {}
        };
        if (query.unit) {
            params.body['unit'] = query.unit
        }
        if (Array.isArray(query.owners) && query.owners.length) {
            params.body['owners'] = query.owners.join(',')
        }
        if (Array.isArray(query.components) && query.components.length) {
            params.body['components'] = query.components.join(',')
        }
        if (Array.isArray(query.status) && query.status.length) {
            params.body['status'] = query.status.join(',')
        }
        if (query.from) {
            params.body['from'] = query.from
        }
        if (query.to) {
            params.body['to'] = query.to
        }

        const res = await super.post<any>(`process/${processID}/dashboard`, params)
        return res
    }
}

